import { Divider, Grid, Typography } from "@mui/material"
import styles from "../../../../Styles/ComponentStyles/ProfileStyle/AnnuityProfilesStyle.module.scss"
import CustomNumberTextField from "../../../../GlobalComponent/CustomNumberTextField/CustomNumberTextField";
import GlobalButton from "../../../../Utils/GlobalUtilsComponents/GlobalButton";
import chartIcon from "../../../../assets/Images/chartIcon.svg"
import { useContext, useEffect, useState } from "react";
import { ProfileContext, ProfileContextPayload } from "../../../../Context/ProfileDetailsContext";
import { useSearchParams } from "react-router-dom";
import AnnuityIncomeOutputChart from "./AnnuityIncomeOutputChart";

const AnnuityIncomeOutput = () => {
    const {
        finalIncomeData,
        surplusDeficitChartData,
    } = useContext(ProfileContext) as ProfileContextPayload

    const [searchParams, setSearchParams] = useSearchParams();
    const [changeYearIncome, setChangeYearIncome] = useState(new Date().getFullYear())
    const [incomeYearMin, setIncomeYearMin] = useState<number | null>(null);
    const [incomeYearMax, setIncomeYearMax] = useState<number | null>(null);
    const [yearWiseClientData, setYearWiseClientData] = useState<any>({})

    useEffect(() => {
        if (finalIncomeData && Object.keys(finalIncomeData).length > 0) {
            const yearOptions = Object.keys(finalIncomeData).map(Number).sort((a, b) => a - b);
            setIncomeYearMin(yearOptions[0]);
            setIncomeYearMax(yearOptions.at(-1) ?? null);

            // Default to the most recent year if no year is set
            if (!changeYearIncome || !finalIncomeData[changeYearIncome]) {
                const latestYear = yearOptions.at(-1);
                if (latestYear !== undefined) {
                    setChangeYearIncome(latestYear);
                }
            }
        }
    }, [finalIncomeData]);

    useEffect(() => {
        if (changeYearIncome && finalIncomeData) {
            setYearWiseClientData(finalIncomeData[changeYearIncome] || {});
        }
    }, [changeYearIncome, finalIncomeData]);

    const isInputBetween = (num1: any, num2: any, value: any) => value > num1 && value < num2;
    const inputBlureChangeYear = (e: any) => {
        let val = Number.parseInt(e.target.value);
        let checkInBeetween = isInputBetween(Number(incomeYearMin), Number(incomeYearMax), val)
        if (!checkInBeetween) {
            if (val >= Number(incomeYearMax)) {
                setChangeYearIncome(Number(incomeYearMax))
            } else {
                setChangeYearIncome(Number(incomeYearMin))
            }
        }
    }
    const inputChangeYear = (e: any) => {
        let val = Number.parseInt(e.target.value);
        if (val >= Number(incomeYearMin) && val <= Number(incomeYearMax)) {
            setChangeYearIncome(val)
        } else if (val >= Number(incomeYearMax)) {
            setChangeYearIncome(Number(incomeYearMax))
        } else {
            setChangeYearIncome(Number(incomeYearMin))
        }
    }

    const surplusOrDeficit = yearWiseClientData?.surplusOrDeficit;
    let surplusDeficitLabel = "Surplus";
    let surplusDeficitChipClass = styles.surplusChipStyle;
    if (surplusOrDeficit == 0) {
        surplusDeficitLabel = "Surplus/Deficit";
        surplusDeficitChipClass = styles.incomeChipsStyle;
    } else if (surplusOrDeficit < 0) {
        surplusDeficitLabel = "Deficit";
        surplusDeficitChipClass = styles.deficitChipStyle;
    }
    const formatNumber = (q: any) => {
        if (q || q == 0) {
            return q.toLocaleString('en-US', {
                style: 'currency',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                currency: "usd"
            })
        }
    }

    const toggleChart = () => {
        if (searchParams.get("showChart") === "true") {
            searchParams.delete("showChart");
        } else {
            searchParams.set("showChart", "true");
        }
        setSearchParams(searchParams);
    };

    return (
        <>
            {searchParams.get("showChart") === "true"
                ?
                <AnnuityIncomeOutputChart chartData={surplusDeficitChartData} />
                :
                <Grid container padding={"0px 20px"}>
                    <Grid item className={styles.globalBlurWrapperForOutputForIncome}>
                        <Grid container gap={"20px"}>
                            {/* Header section */}
                            <Grid item xs={12}>
                                <Grid container justifyContent={"space-between"} width={"100%"}>
                                    <Grid item>
                                        <Typography component={"span"} className={styles.outputTitle}>
                                            Annuity - Income
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Grid container gap="20px" alignItems={"center"}>
                                            <Grid item>
                                                <Grid container gap={"10px"} alignItems={"center"}>
                                                    <Grid item className={styles.yearTxt}>Year</Grid>
                                                    <Grid item>
                                                        <CustomNumberTextField
                                                            type="number"
                                                            size="small"
                                                            variant="outlined"
                                                            defaultValue={new Date().getFullYear()}
                                                            customStyles={{
                                                                width: '100px',
                                                                backgroundColor: "white",
                                                                color: "black"
                                                            }}
                                                            value={changeYearIncome}
                                                            onChange={(e) => {
                                                                setChangeYearIncome(Number(e?.target?.value));
                                                            }}
                                                            InputProps={{ inputProps: { min: incomeYearMin, max: incomeYearMax } }}
                                                            onBlur={inputBlureChangeYear}
                                                            onKeyUp={(e) => {
                                                                if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Enter")
                                                                    inputChangeYear(e);
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item>
                                                <GlobalButton
                                                    value={"Chart"}
                                                    className={styles.chartBtn}
                                                    startIcon={
                                                        <img src={chartIcon} alt="" />
                                                    }
                                                    onClick={toggleChart}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* Remaining container */}
                            <Grid item xs={12} marginBottom={"20px !important "}>
                                <Grid container gap={"20px"}>
                                    {/* Chips section */}
                                    <Grid item xs={12}>
                                        <Grid container gap={2}>
                                            <Grid item xs={11} sm={3} md={3} lg={3} xl={3} className={styles.incomeChipsStyle}>
                                                <Grid container direction={"column"} gap={"4px"}>
                                                    <Grid item className={styles.chipsHeading}>
                                                        <span>Total Annual Income</span>
                                                    </Grid>
                                                    <Grid item className={styles.chipsValue}>
                                                        {formatNumber(yearWiseClientData?.totalAnnualIncome) || "$0"}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={11} sm={3} md={3} lg={3} xl={3} className={styles.incomeChipsStyle}>
                                                <Grid container direction={"column"} gap={"4px"}>
                                                    <Grid item className={styles.chipsHeading}>
                                                        <span>Desired Income</span>
                                                    </Grid>
                                                    <Grid item className={styles.chipsValue}>
                                                        {formatNumber(yearWiseClientData?.totalDesiredIncome) || "$0"}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={11} sm={3} md={3} lg={3} xl={3} className={surplusDeficitChipClass}>
                                                <Grid container direction={"column"} gap={"4px"}>
                                                    <Grid item className={styles.chipsHeading}>
                                                        <span>{surplusDeficitLabel}</span>
                                                    </Grid>
                                                    <Grid item className={styles.chipsValue}>
                                                        {formatNumber(yearWiseClientData?.surplusOrDeficit) || "$0"}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {/* Cards Section */}
                                    <Grid item xs={12}>
                                        <Grid container spacing={2}>
                                            {yearWiseClientData?.clients?.map((client: any) => (
                                                <Grid item key={client.clientResults.clientName}>
                                                    <Grid container className={styles.clientCard}>
                                                        <Grid item xs={12} className={styles.clientNameContainer}>
                                                            <Typography variant="h6" className={styles.clientName}>
                                                                {client.clientResults.clientName}
                                                            </Typography>
                                                        </Grid>

                                                        {/* Main content container - Added display flex and flex-direction column */}
                                                        <Grid
                                                            container
                                                            direction="column"
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection: 'column'
                                                            }}
                                                        >
                                                            {/* Top section with age info */}
                                                            <Grid item>
                                                                <Grid container className={styles.topSection}>
                                                                    <Grid item xs={12}>
                                                                        <Grid container justifyContent={"space-between"}>
                                                                            <Grid item>
                                                                                <Typography className={styles.label}>Current Age</Typography>
                                                                            </Grid>
                                                                            <Grid item>
                                                                                <Typography className={styles.value}>
                                                                                    {client.clientResults.clientAge}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>

                                                                    <Grid item xs={12}>
                                                                        <Grid container justifyContent={"space-between"}>
                                                                            <Grid item>
                                                                                <Typography className={styles.label}>Retirement Age</Typography>
                                                                            </Grid>
                                                                            <Grid item>
                                                                                <Typography className={styles.value}>
                                                                                    {client.clientResults.clientRetirementAge}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                                <Divider
                                                                    style={{
                                                                        opacity: 0.8,
                                                                        borderColor: "#E2E8F0",
                                                                        height: "1px",
                                                                        width: "100%",
                                                                    }}
                                                                />
                                                            </Grid>

                                                            {/* Middle section with income sources - Now only this section scrolls if too long */}
                                                            <Grid item sx={{ flexGrow: 1 }}>
                                                                <Grid container className={styles.middleSection}>
                                                                    <Grid item xs={12}>
                                                                        <Typography
                                                                            sx={{ paddingBottom: "10px !important", fontWeight: "bold" }}
                                                                        >
                                                                            Income
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} sx={{ maxHeight: '150px', minHeight: '150px', overflowY: 'auto' }}>
                                                                        {client.clientResults.incomeSources.data.map((source: any) => (
                                                                            <Grid
                                                                                container
                                                                                justifyContent="space-between"
                                                                                key={source.clientIncomeSourceName}
                                                                                className={styles.incomeRow}
                                                                            >
                                                                                <Typography
                                                                                    className={styles.sourceLabel}
                                                                                    sx={{
                                                                                        whiteSpace: 'nowrap',
                                                                                        overflow: 'hidden',
                                                                                        textOverflow: 'ellipsis',
                                                                                        maxWidth: '140px',
                                                                                        display: 'inline-block',
                                                                                        cursor: 'pointer',
                                                                                    }}
                                                                                    title={source.clientIncomeSourceName}
                                                                                >
                                                                                    {source.clientIncomeSourceName}
                                                                                </Typography>
                                                                                <Typography className={styles.sourceAmount}>
                                                                                    {formatNumber(source.clientIncomeSourceAmount)}
                                                                                </Typography>
                                                                            </Grid>
                                                                        ))}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>

                                                            <Divider
                                                                style={{
                                                                    opacity: 0.8,
                                                                    borderColor: "#E2E8F0",
                                                                    height: "1px",
                                                                    width: "100%",
                                                                }}
                                                            />

                                                            {/* Bottom total section - Will stick to bottom */}
                                                            <Grid item className={styles.bottomSection}>
                                                                <Grid container justifyContent={"space-between"} className={styles.totalContainer}>
                                                                    <Grid item>
                                                                        <Typography className={styles.totalLabel}>Total</Typography>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <Typography className={styles.totalIncome}>
                                                                            {formatNumber(client.clientResults.incomeSources.totalIncome)}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
        </>
    )
}

export default AnnuityIncomeOutput